import { Dropdown as UIDropdown, type DropdownProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

export type { DropdownProps, OptionType } from '@jagad/ui';

const Dropdown = <T extends import('@jagad/ui').OptionType = import('@jagad/ui').OptionType>(
  props: Omit<DropdownProps<T>, 'defaultPlaceholder'>
) => {
  const { t } = useTranslation();
  return (
    <UIDropdown
      {...props}
      defaultPlaceholder={t('components.dropdown.defaultPlaceholder')}
    />
  );
};

export default Dropdown;
